import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import { LayoutSingleColumn, LayoutWrapperTopbar, LayoutWrapperMain } from '../../components';
import { Link } from 'react-router-dom';
import css from './BlogListingPage.module.css';

// Using images from public directory
const menCheatImage = '/static/images/blog/why-do-men-cheat.jpg';
const testBoyfriendImage = '/static/images/blog/test-boyfriend.jpg';
const loyaltyTestImage = '/static/images/blog/loyalty-test.jpg';
const ariProfileImage = '/static/images/blog/Ari_loyalty_tester.png';
const loyaltyTest2026Image = '/static/images/blog/loyalty-test-2026-couple.png';

const BlogListingPage = () => {
  const articles = [
    {
      id: 1,
      title: 'My Thoughts and Experience With a Loyalty Test in 2026',
      description:
        'A first-person story about taking a loyalty test, weighing the ethics, and living with the result.',
      image: loyaltyTest2026Image,
      link: '/my-thoughts-and-experience-with-a-loyalty-test-in-2026',
      author: 'Alice Garcia',
      date: '2026-03-05',
      reads: '1.1k',
    },
    {
      id: 2,
      title: 'How Loyal Is My Partner? - Take the Quiz',
      description:
        "Take this comprehensive quiz to assess your partner's loyalty and get personalized recommendations based on your answers.",
      image: '/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg',
      link: '/how-loyal-is-my-partner-quiz',
      author: 'Jessica Shouland',
      date: '2024-02-04',
      reads: '2.7k',
    },
    {
      id: 3,
      title: 'What I Learned from a Loyalty Test on My (Ex)Husband',
      description:
        'Is your partner staying faithful? Learn how I set up a loyalty test to catch a cheating spouse and gain closure.',
      image: ariProfileImage,
      author: 'Anonymous',
      reads: '5.2k',
      link: '/what-i-learned-from-loyalty-test',
    },
    {
      id: 4,
      title: 'Why Do Men Cheat?',
      description:
        'Understand the psychology behind infidelity and what drives men to cheat in relationships.',
      image: menCheatImage,
      author: 'Precious Ogunkoya',
      reads: '18.4k',
      link: '/WhyDoMenCheat',
    },
    {
      id: 5,
      title: 'How to Test Your Boyfriend (Without Hurting Your Relationship)',
      description:
        'Learn to recognize the subtle and obvious signs that could indicate infidelity in your relationship.',
      image: testBoyfriendImage,
      author: 'Sarah Johnson',
      reads: '12.3k',
      link: '/how-to-test-your-boyfriend',
    },
    {
      id: 6,
      title: 'Loyalty Test Website',
      description: 'A Loyalty Test Website: Your Most Pressing Questions Answered',
      image: loyaltyTestImage,
      author: 'Michael Chen',
      reads: '9.8k',
      link: '/loyalty-test-website',
    },
  ];

  return (
    <StaticPage
      title="Blog"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Blog',
        description: 'Articles about relationships, loyalty, and trust',
        name: 'Blog page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Blog</h1>

          <div className={css.articlesGrid}>
            {articles.map(article => (
              <Link
                to={article.link}
                key={`${article.id}-${article.link}`}
                className={css.articleCard}
              >
                <div className={css.imageWrapper}>
                  <img
                    src={article.image}
                    alt={article.title}
                    className={css.articleImage}
                    loading="lazy"
                    decoding="async"
                    fetchpriority="low"
                  />
                </div>
                <div className={css.articleContent}>
                  <h2 className={css.articleTitle}>{article.title}</h2>
                  <p className={css.articleDescription}>{article.description}</p>
                  <div className={css.articleMeta}>
                    <span className={css.author}>{article.author}</span>
                    {article.reads && (
                      <>
                        <span className={css.dot}>•</span>
                        <span className={css.reads}>{article.reads} reads</span>
                      </>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </LayoutWrapperMain>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default BlogListingPage;
